var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStackedGoldOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6495 22.0006C16.5326 21.4273 16.2183 20.9132 15.7616 20.5475C15.3046 20.1822 14.7341 19.9883 14.1491 20.0002H8.29817C7.71312 19.9883 7.14262 20.1822 6.68566 20.5475C6.22896 20.9132 5.91462 21.4273 5.79776 22.0006L3.74744 32.5022H18.7498L16.6495 22.0006Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1523 22.0006C34.0352 21.4273 33.7214 20.9132 33.2644 20.5475C32.8075 20.1822 32.2367 19.9883 31.6519 20.0002H25.801C25.2159 19.9883 24.6454 20.1822 24.1885 20.5475C23.7318 20.9132 23.4174 21.4273 23.3006 22.0006L21.2502 32.5022H36.2526L34.1523 22.0006Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5012 20.0003L25.4008 9.49857C25.284 8.92526 24.9697 8.41115 24.5129 8.04553C24.056 7.68017 23.4855 7.48626 22.9004 7.49825H17.0495C16.4645 7.48626 15.894 7.68017 15.437 8.04553C14.9803 8.41115 14.666 8.92526 14.5491 9.49857L12.4988 20.0003",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1993 20.0002H25.8012",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStackedGoldOutline);
export default __webpack_public_path__ + "static/media/icon_stacked_gold_outline.ff6997d0896a3f7520f26cfc62ac84ab.svg";
export { ForwardRef as ReactComponent };